import LogsPanelContext from '@crm/contexts/LogsPanelContext'
import { DayLabel, Text } from '@shared/components'
import { Button, Col, Flex, Row, Space } from 'antd'
import { Call } from 'iconsax-react'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { ActivityLogAvatar } from './ActivityLogAvatar'
import { ActivityLogProps } from './types'
import { useGetTranslatedDescription } from './useGetTranslatedDescription'

export const ActivityLogCall = ({ log }: ActivityLogProps) => {
  const { t } = useTranslation()
  const translatedDescription = useGetTranslatedDescription({ log })

  const { openPlayer } = useContext(LogsPanelContext)

  const handleOpenPlayer = () => {
    if (log.call) {
      openPlayer(log.call)
    }
  }

  return (
    <Row justify="space-between" gutter={[16, 16]} align="middle">
      <Col xs={24} xl={12} xxl={12}>
        <Text isEllipsis>{translatedDescription}</Text>
      </Col>

      <Flex gap={8} wrap justify="end" align="center">
        <ActivityLogAvatar
          user={log?.created_by}
          label={t('task.created_by')}
        />

        <DayLabel date={log?.created_at} />

        <Space.Compact>
          <Button
            size="small"
            disabled={!log.call?.attachment?.file}
            onClick={handleOpenPlayer}
            icon={<Call />}
          />
        </Space.Compact>
      </Flex>
    </Row>
  )
}
